// extracted by mini-css-extract-plugin
export default {"background":"layout_background__dVQrg"};